import { useIntlDateRangeFormatter } from 'lib/datetime/dateUtils'
import { memo } from 'react'
import type { DateTimeFormat } from './dateTimeFormats'
import { DATE_TIME_FORMATS } from './dateTimeFormats'

interface BaseProps {
  startValue: Date | moment.Moment | string
  endValue: Date | moment.Moment | string
}

interface PropsWithFormat extends BaseProps {
  format: DateTimeFormat
}

interface PropsWithOptions extends BaseProps, Intl.DateTimeFormatOptions {
  format?: undefined
}

function isPropsWithOptions(props: Props): props is PropsWithOptions {
  return props.format === undefined
}

type Props = PropsWithFormat | PropsWithOptions

/**
 * [MDN Reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#date-time_component_options)
 */
function FormatDateTimeRange(props: Props) {
  const formatter = useIntlDateRangeFormatter()

  if (isPropsWithOptions(props)) {
    const { startValue, endValue, ...options } = props
    return <>{formatter(startValue, endValue, options)}</>
  } else {
    const { startValue, endValue, format } = props
    return <>{formatter(startValue, endValue, DATE_TIME_FORMATS[format])}</>
  }
}

export default memo(FormatDateTimeRange)
